import * as React from 'react';
import { SVGProps } from 'react';

const SvgStatusProcessing = (props: SVGProps<SVGSVGElement>) => (
  <svg width={80} height={80} viewBox="0 0 80 80" fill="none" role="img" {...props}>
    <circle cx={40} cy={40} r={40} fill="#E9F9FB" />
    <rect x={8} y={8} width={64} height={64} rx={32} fill="#fff" />
    <mask id="a" fill="#fff">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M40 72c17.673 0 32-14.327 32-32C72 22.327 57.673 8 40 8 22.327 8 8 22.327 8 40c0 17.673 14.327 32 32 32Zm1.5-45a1.5 1.5 0 0 0-3 0v13.739l13.585 10.45a1.5 1.5 0 1 0 1.83-2.378L41.5 39.261V27Z"
      />
    </mask>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M40 72c17.673 0 32-14.327 32-32C72 22.327 57.673 8 40 8 22.327 8 8 22.327 8 40c0 17.673 14.327 32 32 32Zm1.5-45a1.5 1.5 0 0 0-3 0v13.739l13.585 10.45a1.5 1.5 0 1 0 1.83-2.378L41.5 39.261V27Z"
      fill="#6AD5E5"
    />
    <path
      d="M38.5 40.739h-2v.984l.78.6 1.22-1.584Zm13.585 10.45-1.219 1.585 1.22-1.585Zm1.83-2.378-1.22 1.585 1.22-1.585ZM41.5 39.261h-2v.985l.78.6 1.22-1.585ZM70 40c0 16.569-13.431 30-30 30v4c18.778 0 34-15.222 34-34h-4ZM40 10c16.569 0 30 13.431 30 30h4C74 21.222 58.778 6 40 6v4ZM10 40c0-16.569 13.431-30 30-30V6C21.222 6 6 21.222 6 40h4Zm30 30c-16.569 0-30-13.431-30-30H6c0 18.778 15.222 34 34 34v-4Zm0-42.5a.5.5 0 0 1-.5-.5h4a3.5 3.5 0 0 0-3.5-3.5v4Zm.5-.5a.5.5 0 0 1-.5.5v-4a3.5 3.5 0 0 0-3.5 3.5h4Zm0 13.739V27h-4v13.739h4Zm12.805 8.865-13.586-10.45-2.438 3.17 13.585 10.45 2.439-3.17Zm-.701.091a.5.5 0 0 1 .7-.091l-2.438 3.17a3.5 3.5 0 0 0 4.908-.64l-3.17-2.439Zm.091.701a.5.5 0 0 1-.091-.7l3.17 2.438a3.5 3.5 0 0 0-.64-4.908l-2.439 3.17Zm-12.414-9.55 12.414 9.55 2.439-3.17-12.415-9.55-2.438 3.17ZM39.5 27v12.261h4V27h-4Z"
      fill="#fff"
      mask="url(#a)"
    />
  </svg>
);

export default SvgStatusProcessing;
